import { getViteEnv } from 'test/viteEnv';

type ApiBaseUrlEnv = {
  VITE_API_BASE_URL?: string;
};

/** Shown when API base URL is unset at runtime. */
export const MISSING_API_BASE_URL_MESSAGE =
  'Unable to load application services. Please try again later or contact support.';

/** Returns a configuration error message when the API base URL is missing; otherwise null. */
export function getApiBaseUrlConfigurationError(env: ApiBaseUrlEnv = getViteEnv()): string | null {
  const raw = env.VITE_API_BASE_URL?.trim() ?? '';
  return raw.length > 0 ? null : MISSING_API_BASE_URL_MESSAGE;
}

/**
 * Resolves `VITE_API_BASE_URL` for API clients.
 * Throws when unset so callers never silently fall back to a development endpoint.
 */
export function getRequiredApiBaseUrl(env: ApiBaseUrlEnv = getViteEnv()): string {
  const configurationError = getApiBaseUrlConfigurationError(env);
  if (configurationError) {
    throw new Error(configurationError);
  }

  return (env.VITE_API_BASE_URL as string).trim().replace(/\/$/, '');
}
